import { useMemo } from "react";

/**
 * Vector-drawn CPD-style accreditation seal.
 *
 * Mimics the look of a "CPD Certification Service - Accredited Member" stamp:
 * deep purple ring with curved text on top and bottom and a bold "CPD"
 * monogram in the centre.
 */
export default function CpdSeal({ size = 140 }) {
  const id = useMemo(() => `cpd-${Math.random().toString(36).slice(2, 8)}`, []);
  const PURPLE = "#5E2A8A";
  const PURPLE_LIGHT = "#7E3FB3";
  const CREAM = "#FBF7EE";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="CPD Certification Service - Accredited Member"
      data-testid="cpd-seal"
    >
      <defs>
        <path
          id={`${id}-top`}
          d="M 30 100 A 70 70 0 0 1 170 100"
          fill="none"
        />
        <path
          id={`${id}-bottom`}
          d="M 35 110 A 65 65 0 0 0 165 110"
          fill="none"
        />
      </defs>

      {/* outer purple ring */}
      <circle cx="100" cy="100" r="96" fill={PURPLE} />
      {/* cream disc */}
      <circle cx="100" cy="100" r="74" fill={CREAM} />
      {/* thin separator ring */}
      <circle cx="100" cy="100" r="80" fill="none" stroke={PURPLE_LIGHT} strokeWidth="0.8" />

      {/* curved top text */}
      <text
        fill="#FFFFFF"
        fontFamily="Chivo, IBM Plex Sans, sans-serif"
        fontWeight="800"
        fontSize="13"
        letterSpacing="2.2"
      >
        <textPath href={`#${id}-top`} startOffset="50%" textAnchor="middle">
          THE CPD CERTIFICATION SERVICE
        </textPath>
      </text>

      {/* curved bottom text */}
      <text
        fill="#FFFFFF"
        fontFamily="Chivo, IBM Plex Sans, sans-serif"
        fontWeight="800"
        fontSize="11"
        letterSpacing="3"
      >
        <textPath href={`#${id}-bottom`} startOffset="50%" textAnchor="middle">
          ★ ACCREDITED MEMBER ★
        </textPath>
      </text>

      {/* center monogram */}
      <text
        x="100"
        y="108"
        textAnchor="middle"
        fill={PURPLE}
        fontFamily="Chivo, IBM Plex Sans, sans-serif"
        fontWeight="900"
        fontSize="56"
        letterSpacing="-2"
      >
        CPD
      </text>

      {/* subline */}
      <text
        x="100"
        y="128"
        textAnchor="middle"
        fill={PURPLE_LIGHT}
        fontFamily="IBM Plex Mono, monospace"
        fontWeight="700"
        fontSize="9"
        letterSpacing="3"
      >
        CERTIFIED
      </text>
    </svg>
  );
}
